<div class="success-modal">
  <h2>
    <md-icon *ngIf="type === 'success'">check_circle</md-icon>
    <md-icon *ngIf="type === 'warning'">warning</md-icon>
    <md-icon *ngIf="type === 'error'" class="error">error</md-icon>
  </h2>
  <h3 [ngClass]="{error: type=='error'}">{{message}}</h3>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/success/success.component.html